import api from 'app/api';
import { globalQueryClient } from 'app/configs/queryClientConfig';
import { getFileSetIds } from 'app/utils/fileSet';
import {
  decodeURL,
  encodeString,
  formatFileSetData,
  getParamsFromEncodedString,
  getParamsObjFromEncodedString,
  updateNextDataURL,
} from 'app/utils/helpers';
import { infoToast } from 'app/utils/toast';
import queryString from 'query-string';
import store from 'store';

import {
  ADDED_FOR_TRAINING,
  NOT_ADDED_FOR_TRAINING,
  REMOVE_SELECTED_FILES,
  RESET_MODEL_TRAINING,
  RESET_RADIO_CONFIG,
  RESET_TRAINING,
  SET_ACTIVE_IMG,
  SET_ACTIVE_TRAINING_MODE,
  SET_DEFECT_INSTANCES_COUNT,
  SET_DIALOG_OPEN,
  SET_DIALOG_VARIANT,
  SET_EDIT_MODE,
  SET_EPOCH_COUNT,
  SET_FETCHING_TRAINING_FILESETS,
  SET_FILE_SET_COUNT,
  SET_FILE_SET_DATA,
  SET_FILE_SET_DEFECTS,
  SET_FILE_SET_DEFECTS_LOADING,
  SET_IMAGE_RESOLUTION,
  SET_IS_VIEW_DETAILS,
  SET_MODEL_LIB_ACTIVE_STEP,
  SET_MODEL_NAME,
  SET_MODEL_TRAINING_CONTAINER_META,
  SET_MODEL_USECASE,
  SET_NEW_MODEL,
  SET_OLD_MODEL,
  SET_PENDING_TASK_ID,
  SET_RADIO_CONFIG,
  SET_SAME_MODEL_NAME_ERROR,
  SET_SELECT_ALL,
  SET_SELECTED_DEFECTS,
  SET_SHOULD_TRAINING_OPEN,
  SET_TRAINING_COUNT,
  SET_TRAINING_DATA_INFORMATION,
  SET_TRAINING_FILESET_NEXT_API,
  SET_TRAINING_PROGRESS_VALUE,
  UPDATE_MODEL_FILESET_TAG_BY_INDEX,
} from './constants';

const TRAINING_MODE_STATUS = {
  [ADDED_FOR_TRAINING]: 'TRAIN,TEST,VALIDATION,',
  [NOT_ADDED_FOR_TRAINING]: 'NOT_TRAINED',
};

export function setActiveStep(payload) {
  return { type: SET_MODEL_LIB_ACTIVE_STEP, payload };
}

export function setModelName(payload) {
  return { type: SET_MODEL_NAME, payload };
}

export function setNewModel(payload) {
  return { type: SET_NEW_MODEL, payload };
}

export function setEditMode(payload) {
  return { type: SET_EDIT_MODE, payload };
}

export function setDialogOpen(payload) {
  return { type: SET_DIALOG_OPEN, payload };
}

export function setDialogVariant(payload) {
  return { type: SET_DIALOG_VARIANT, payload };
}

export function resetTraining() {
  return { type: RESET_TRAINING };
}

export function setActiveImg(payload) {
  return { type: SET_ACTIVE_IMG, payload };
}

export function setSelectAll(payload) {
  return { type: SET_SELECT_ALL, payload };
}

export function setFileSetData(payload) {
  return { type: SET_FILE_SET_DATA, payload };
}

export function setDefectsInstancesCount(payload) {
  return { type: SET_DEFECT_INSTANCES_COUNT, payload };
}
export function setFileSetCount(payload) {
  return { type: SET_FILE_SET_COUNT, payload };
}

export function setModelUseCase(payload) {
  return { type: SET_MODEL_USECASE, payload };
}

export function setOldModel(payload) {
  return { type: SET_OLD_MODEL, payload };
}

export function setSelectedDefects(payload) {
  return { type: SET_SELECTED_DEFECTS, payload };
}

export function setSameModelNameError(payload) {
  return { type: SET_SAME_MODEL_NAME_ERROR, payload };
}

export function setFileSetDefectsLoading() {
  return { type: SET_FILE_SET_DEFECTS_LOADING, payload: true };
}

export function fetchFileSetDefects(
  fileSetFilters,
  modelFilters,
  trainingSessionId
) {
  return dispatch => {
    const getAnnotationList = window.location.pathname.includes(
      'show-training-data'
    )
      ? api.annotationDefectsByFileSetTrainingGt
      : api.annotationDefectsByFileSet;

    dispatch(setFileSetDefectsLoading());

    getAnnotationList(fileSetFilters, modelFilters, trainingSessionId)
      .then(res => {
        dispatch({ type: SET_FILE_SET_DEFECTS, payload: res || {} });
      })
      .catch(() => {
        dispatch({ type: SET_FILE_SET_DEFECTS, payload: {} });
      });
  };
}

export function getDefect(ids = [], modelId, trainingSessionId) {
  return dispatch => {
    const encodedFilesetFilters = btoa(`id__in=${ids.join(',')}`);

    let encodedModelFilter = '';

    if (modelId) {
      encodedModelFilter = btoa(
        `ml_model_id__in=${modelId}&is_inferenced=true`
      );
    } else {
      const urlParam = getParamsObjFromEncodedString(window.location.search);

      encodedModelFilter = btoa(
        `model_selection=${
          urlParam.model_selection ?? 'latest'
        }&is_inferenced=true`
      );
    }

    dispatch(
      fetchFileSetDefects(
        encodedFilesetFilters,
        encodedModelFilter,
        trainingSessionId
      )
    );
  };
}

export function setActiveTrainingMode(payload) {
  return { type: SET_ACTIVE_TRAINING_MODE, payload };
}

export function removeSelectedFiles() {
  return { type: REMOVE_SELECTED_FILES };
}

export function setPendingTaskId(payload) {
  return { type: SET_PENDING_TASK_ID, payload };
}

export function setShouldTrainingOpen(payload) {
  return { type: SET_SHOULD_TRAINING_OPEN, payload };
}

export const setTrainingFilesCount = payload => {
  return {
    type: SET_TRAINING_COUNT,
    payload,
  };
};

export function setConfigRadio(payload) {
  return { type: SET_RADIO_CONFIG, payload };
}

export function setProgressValue(payload) {
  return { type: SET_TRAINING_PROGRESS_VALUE, payload };
}

export function setEpochCount(payload) {
  return { type: SET_EPOCH_COUNT, payload };
}

export function setImageResolution(payload) {
  return { type: SET_IMAGE_RESOLUTION, payload };
}

export function resetConfigRadio() {
  return { type: RESET_RADIO_CONFIG };
}

export function setTrainingDataInformation(payload) {
  return { type: SET_TRAINING_DATA_INFORMATION, payload };
}

export function setIsViewDetails(payload) {
  return { type: SET_IS_VIEW_DETAILS, payload };
}

export function setFetchingTrainingFilesets(payload) {
  return { type: SET_FETCHING_TRAINING_FILESETS, payload };
}

export function setTrainingFileSetNextApi(payload) {
  return { type: SET_TRAINING_FILESET_NEXT_API, payload };
}

export function setTrainingFileSet(payload) {
  return dispatch => {
    const { data, isNewData, trainingSessionId } = payload;
    const filteredData = formatFileSetData(data);

    if (filteredData.length) {
      dispatch(
        getDefect(
          filteredData.map(x => x.fileSetId),
          undefined,
          trainingSessionId
        )
      );
    }

    dispatch(setFileSetData({ data: filteredData, isNewData }));
  };
}

export function trainingFilesetDataFetcher(
  suffix,
  modelId,
  subId,
  trainingSessionId
) {
  return function (dispatch) {
    return api
      .getFileSets('', 50, undefined, subId, `${suffix}&cursor=`)
      .then(res => {
        dispatch(setTrainingFileSetNextApi(updateNextDataURL(res.next)));

        dispatch(
          setTrainingFileSet({
            data: res.results ?? [],
            isNewData: true,
            modelId,
            trainingSessionId,
          })
        );
      });
  };
}

const getFilesetCount = async (subId, params) => {
  const { count } = await api.getFileSets('', 1, 0, subId, params);
  return count;
};

export const getTrainingFileSetApiParams = (
  locationParams,
  mode,
  removeOtherFilters = false,
  trainingModelId
) => {
  const { newModel } = store.getState().modelTraining;
  let finalParams = locationParams;

  const params = queryString.parse(finalParams);

  if (removeOtherFilters) {
    delete params.other_filters;
    finalParams = queryString.stringify(params);
  }

  const train_type__in =
    decodeURL(params.other_filters)?.['train_type__in'] ??
    TRAINING_MODE_STATUS[mode];

  return `${finalParams}&train_type__in=${train_type__in}&training_ml_model__in=${
    newModel.id ?? trainingModelId
  }${mode === ADDED_FOR_TRAINING ? '' : '&is_gt_classified=true'}`;
};

export function setTrainingCount(locationParam, subId, useCaseId) {
  globalQueryClient.invalidateQueries({ queryKey: ['fileSets'] });
  locationParam += `&use_case_id__in=${useCaseId}`;

  return async (dispatch, getState) => {
    const addedRes = await api.getFileSets(
      'addedToTrainingFileCount',
      1,
      0,
      subId,
      getTrainingFileSetApiParams(locationParam, ADDED_FOR_TRAINING, true)
    );

    const notAddedRes = await api.getFileSets(
      'notAddedToTrainingFileCount',
      1,
      0,
      subId,
      getTrainingFileSetApiParams(locationParam, NOT_ADDED_FOR_TRAINING, true)
    );

    const { activeTrainingMode } = getState().modelTraining;

    const fileSetCount = await getFilesetCount(
      subId,
      getTrainingFileSetApiParams(locationParam, activeTrainingMode)
    );

    dispatch(setFileSetCount(fileSetCount));

    dispatch(
      setTrainingFilesCount({
        addedToTraining: addedRes.count,
        notAddedToTraining: notAddedRes.count,
      })
    );
  };
}

export const fetchFileSets = (
  locationParam,
  activeImageMode,
  subId,
  useCaseId,
  trainingSessionId
) => {
  return async dispatch => {
    dispatch(setFetchingTrainingFilesets(true));
    if (trainingSessionId) {
      locationParam += `&training_session_id=${trainingSessionId}`;
    }

    await dispatch(setTrainingCount(locationParam, subId, useCaseId));

    if (store.getState().modelTraining.count === 0) {
      dispatch(setFetchingTrainingFilesets(false));
      return;
    }

    const fileSetParams = `${getTrainingFileSetApiParams(
      locationParam,
      activeImageMode
    )}&use_case_id__in=${useCaseId}`;

    dispatch(
      trainingFilesetDataFetcher(
        fileSetParams,
        undefined,
        subId,
        trainingSessionId
      )
    );
  };
};

export function setContainerMeta(payload) {
  return { type: SET_MODEL_TRAINING_CONTAINER_META, payload };
}

export function resetModelTraining() {
  return { type: RESET_MODEL_TRAINING };
}

function updateFileSetTagsByIndex(payload) {
  return { type: UPDATE_MODEL_FILESET_TAG_BY_INDEX, payload };
}

export function handleAddImageTags(tags) {
  const { getState, dispatch } = store;
  const { activeImg, selectAll, fileSetData } = getState().modelTraining;

  tags.forEach(d => {
    if (!d.description) {
      d.description = '';
    }
  });

  let encodedString = null;

  if (!selectAll) {
    encodedString = btoa(
      `id__in=${getFileSetIds(selectAll, activeImg, fileSetData)}`
    );
  } else {
    encodedString = encodeString(
      getParamsFromEncodedString(window.location.search, true)
    );
  }

  api
    .updateTagsOnFilesets({
      tag_ids: tags.map(x => x.id),
      file_set_filters: encodedString,
    })
    .then(() => {
      infoToast('Tags Added to images successfully');

      if (selectAll && fileSetData.length >= 50) {
        window.location.reload();
        return;
      } else if (selectAll) {
        fileSetData.map((_, index) =>
          dispatch(updateFileSetTagsByIndex({ index, tags, type: 'add' }))
        );
      } else if (activeImg.length < 50) {
        activeImg.map(index =>
          dispatch(updateFileSetTagsByIndex({ index, tags, type: 'add' }))
        );
      } else {
        infoToast('Please refresh to see updated tags.');
      }
    })
    .catch(() => {
      infoToast('Something went wrong.');
    });
}

export function handleRemoveImageTags(tags, isAllRemove = false) {
  const { getState, dispatch } = store;
  const { activeImg, selectAll, fileSetData } = getState().modelTraining;

  let encodedString = null;

  if (!selectAll) {
    encodedString = btoa(
      `id__in=${getFileSetIds(selectAll, activeImg, fileSetData)}`
    );
  } else {
    encodedString = encodeString(
      getParamsFromEncodedString(window.location.search, true)
    );
  }

  api
    .removeTagsOnFilesets(
      isAllRemove
        ? { remove_all_tags: true, file_set_filters: encodedString }
        : { tag_ids: tags.map(x => x.id), file_set_filters: encodedString }
    )
    .then(() => {
      infoToast('Tags removed from images successfully');
      if (selectAll && fileSetData.length >= 50) {
        window.location.reload();
        return;
      } else if (selectAll) {
        fileSetData.map((_, index) =>
          dispatch(updateFileSetTagsByIndex({ index, tags, type: 'remove' }))
        );
      }
      if (activeImg.length < 50) {
        activeImg.map(index =>
          dispatch(updateFileSetTagsByIndex({ index, tags, type: 'remove' }))
        );
      } else {
        infoToast('Please refresh to see updated tags.');
      }
    })
    .catch(() => {
      infoToast('Something went wrong.');
    });
}
